import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shopping-car",
  "use": "icon-shopping-car-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shopping-car\"><path d=\"M727.04 648.533c10.468 0 19.57-7.054 22.073-17.066l80.782-318.578c1.82-6.827 0.228-14.109-4.096-19.57s-10.923-8.875-17.977-8.875H233.927l-18.432-73.728a22.642 22.642 0 0 0-22.073-17.294H102.4c-12.516 0-22.756 10.24-22.756 22.756s10.24 22.755 22.756 22.755h73.273l18.432 73.728 80.782 318.578c0.683 2.503 1.593 4.779 2.958 6.827l-37.319 93.07c-2.73 7.054-1.82 15.019 2.276 21.163 4.323 6.144 11.378 10.012 18.887 10.012H762.31c12.516 0 22.756-10.24 22.756-22.755S774.827 716.8 762.31 716.8H295.367l27.307-68.267H727.04zM245.532 329.956h533.163l-69.177 273.066H314.482l-68.95-273.066zM284.444 853.333a45.511 45.511 0 1 0 91.023 0 45.511 45.511 0 1 0-91.023 0zM648.534 853.333a45.511 45.511 0 1 0 91.022 0 45.511 45.511 0 1 0-91.023 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/shopping-car.svg
// module id = 1E01
// module chunks = 65